export const translations = {
  de: {
    nav: {
      home: "Startseite",
      about: "Über uns",
      packages: "Packages",
      services: "Services",
      impressions: "Eindrücke",
      reviews: "Bewertungen",
      faq: "FAQ",
      contact: "Kontakt",
      cta: "Kennenlerngespräch buchen",
      inquiry: "Unverbindlich anfragen",
    },
    common: {
      more: "Mehr erfahren",
      requestPackage: "Package anfragen",
      requestService: "Service anfragen",
      priceOnRequest: "Preis auf Anfrage",
      from: "ab",
      send: "Senden",
      sending: "Wird gesendet…",
      back: "Zurück",
      next: "Weiter",
      required: "Pflichtfeld",
      optional: "optional",
      loading: "Laden…",
    },
    hero: {
      brand: "Our Promise Events",
      claim: "Eure Vision.\nUnser Versprechen.",
      subtitle: "Hochzeiten und Events – mit Herz geplant, stilvoll umgesetzt.",
      cta1: "Packages entdecken",
      cta2: "Unverbindlich anfragen",
    },
    brandMessage: {
      overline: "Willkommen",
      title: "Euer Anlass. In besten Händen.",
      body: "Our Promise Events begleitet euch persönlich, organisiert sorgfältig und sorgt für eine stilvolle Umsetzung. Lehnt euch zurück und geniesst euren Anlass – wir übernehmen Planung, Organisation und Koordination.",
    },
    process: {
      overline: "Ablauf",
      title: "In vier Schritten zu eurem Tag",
      steps: [
        { t: "Kennenlernen", d: "Wir lernen euch, eure Wünsche und eure Vision kennen." },
        { t: "Wünsche & Konzept", d: "Gemeinsam definieren wir Konzept, Stil und Rahmen." },
        { t: "Planung & Koordination", d: "Wir organisieren, verhandeln und koordinieren alle Details." },
        { t: "Entspannt geniessen", d: "Ihr geniesst euren Anlass – wir kümmern uns um den Rest." },
      ],
    },
    home: {
      packagesOverline: "Packages",
      packagesTitle: "Unsere Packages",
      packagesSub: "Drei Wege zu eurem perfekten Tag",
      servicesOverline: "Services",
      servicesTitle: "Unsere Services",
      servicesSub: "Professionelle Unterstützung für euren Anlass",
      impressionsOverline: "Eindrücke & Bewertungen",
      impressionsTitle: "Momente, die bleiben",
      impressionsSub: "Ausgewählte, freigegebene Eindrücke unserer Kundinnen und Kunden",
      reviewsOverline: "Bewertungen",
      reviewsTitle: "Was unsere Kundinnen und Kunden sagen",
      instagramOverline: "Folgt uns",
      instagramTitle: "Aktuelle Eindrücke auf Instagram",
      instagramSub: "Hinter den Kulissen, inspirierende Momente und aktuelle Anlässe.",
      instagramCta: "Auf Instagram folgen",
      finalTitle: "Lasst uns euren besonderen Anlass gemeinsam planen.",
      finalSub: "Ob Hochzeit, Verlobung oder Firmenevent – wir begleiten euch von der ersten Idee bis zum letzten Detail.",
    },
    about: {
      overline: "Über uns",
      title: "Mit Herz, Struktur und Stil",
      founderTitle: "Lernen wir uns kennen",
      founderName: "M. Koko",
      founderRole: "Gründerin & Inhaberin",
      valuesTitle: "Unsere Werte",
      storyTitle: "Unsere Geschichte",
      teamTitle: "Unser Team",
      teamEmpty: "Unser Team wird in Kürze vorgestellt.",
      paragraphs: [
        "Jede unvergessliche Feier beginnt mit einer Vision – und genau daraus entstand Our Promise Event.",
        "Ich bin M. Koko, Gründerin und Inhaberin von Our Promise Event. Was einst mit der Planung meiner eigenen Hochzeit sowie von Babyshowers und Geburtstagsfeiern im Familien- und Freundeskreis begann, entwickelte sich Schritt für Schritt zu einer Herzensangelegenheit und schliesslich zu meinem eigenen Eventmanagement.",
        "Für mich ist Our Promise Event weit mehr als ein Unternehmen – es ist die Möglichkeit, Menschen besondere Momente zu schenken. Ich bin davon überzeugt, dass Erinnerungen das Wertvollste sind, was uns ein Leben lang begleitet. Genau deshalb ist es meine Leidenschaft, einzigartige Erlebnisse zu gestalten, die Menschen auch Jahre später noch mit einem Lächeln und Wärme im Herzen in Erinnerung behalten.",
        "Jede Feier erzählt ihre eigene Geschichte. Deshalb nehme ich mir die Zeit, die Wünsche und Vorstellungen meiner Kundinnen und Kunden kennenzulernen und sie mit viel Liebe zum Detail, Kreativität und Professionalität Wirklichkeit werden zu lassen.",
        "Mir ist es wichtig zu zeigen, dass eine stilvolle und unvergessliche Feier nicht unbezahlbar sein muss. Mit einer durchdachten Planung und kreativen Lösungen entwickle ich Konzepte, die zum vorhandenen Budget passen, ohne dabei auf Qualität, Eleganz oder eine persönliche Note zu verzichten.",
      ],
      teamIntro: "Besonders am Herzen liegt mir, Menschen Momente zu schenken, die sie ein Leben lang begleiten. Genau dieser Gedanke hat mich auch bei der Auswahl meines Teams geprägt. Hinter Our Promise Event stehen Menschen, die mich teilweise seit vielen Jahren begleiten.",
      teamParagraphs: [
        "Unser Team besteht ausschliesslich aus engagierten Fachfrauen und Fachmännern, die ihren Beruf mit Leidenschaft ausüben. Ob Service, Reinigung, Sicherheit, Informatik oder weitere Bereiche – jede einzelne Person bringt Fachwissen, Erfahrung und Herzblut mit. Gemeinsam setzen wir alles daran, unseren Kundinnen und Kunden nicht einfach eine Veranstaltung zu organisieren, sondern ein Erlebnis zu schaffen, das sie und ihre Gäste nie vergessen werden.",
        "Für uns zählt nicht nur ein perfekt geplanter Anlass, sondern vor allem das Gefühl, das am Ende eines besonderen Tages bleibt: Freude, Dankbarkeit, Emotionen und unvergessliche Augenblicke. Denn am Ende sind es nicht materielle Dinge, die uns bleiben, sondern die Erinnerungen und Herzensmomente, die wir gemeinsam schaffen.",
      ],
    },
    packages: {
      overline: "Tarife & Prestationen",
      title: "Packages",
      sub: "Event Planung und Koordination",
      highlight: "Umfassendste Begleitung",
      note: "Zusätzliche Wünsche und nicht ausdrücklich enthaltene Fremdkosten werden separat offeriert.",
      cta: "Package anfragen",
      items: {
        bronze: {
          name: "Bronze Package",
          features: [
            "2 Sitzungen",
            "Offerten einholen und aushandeln",
            "Alle Verträge für den Tag abschliessen",
            "Tagesplan erstellen und besprechen",
          ],
        },
        silber: {
          name: "Silber Package",
          features: [
            "2 Sitzungen",
            "Offerten einholen und aushandeln",
            "Alle Verträge für den Tag abschliessen",
            "Tagesplan erstellen",
            "Einladungen erstellen und bestellen (Produktionskosten nicht inbegriffen)",
            "Internetseite erstellen (nicht im Package-Preis inbegriffen)",
          ],
        },
        gold: {
          name: "Gold Package",
          features: [
            "3 bis 4 Sitzungen",
            "Offerten einholen und aushandeln",
            "Alle Verträge für den Tag abschliessen",
            "Tagesplan erstellen",
            "Einladungen erstellen und bestellen (Produktionskosten nicht inbegriffen)",
            "Internetseite erstellen (nicht im Package-Preis inbegriffen)",
            "Tageskoordination von 07:00 bis 22:30 Uhr",
          ],
        },
      },
    },
    services: {
      overline: "Services",
      title: "Unsere Services",
      sub: "Jeder Service kann einzeln angefragt werden",
      surcharge: "Zusatzleistungen und Spesen werden je nach Aufwand separat verrechnet.",
      cta: "Service anfragen",
      list: {
        reinigungsservice: {
          name: "Reinigungsservice",
          price: "CHF 2'060.–",
          intro: "Damit ihr euren Anlass ganz entspannt geniessen könnt, kümmern wir uns um die Reinigung. Unser Team besteht aus professionellen Fachfrauen mit viel Erfahrung in der Reinigung.",
          featuresTitle: "Unser Reinigungsservice umfasst:",
          features: [
            "Laufende Kontrolle und Pflege der Innen- und Aussenbereiche während des Anlasses",
            "Geschirr, Gläser und Besteck abwaschen",
            "WC-Anlagen reinigen",
            "Tische und Ablagen reinigen",
            "Böden besenrein reinigen",
          ],
          extra: "Bei Bedarf übernehmen wir zusätzlich das Aufräumen und Reinigen der Küche, sofern dieser Service nicht bereits vom Catering-Team übernommen wird. Auch eine Nassreinigung der Böden kann dazugebucht werden. Diese Zusatzleistungen werden je nach Aufwand separat verrechnet. Wir sorgen dafür, dass eure Location während des gesamten Anlasses und auch danach sauber, gepflegt und bereit für die Rückgabe ist – zuverlässig, sorgfältig und mit viel Liebe zum Detail.",
        },
        serviceTeam: {
          name: "Service-Team",
          price: "CHF 2'540.–",
          intro: "Geniesst euren Anlass – unser Service-Team kümmert sich um eure Gäste. Unsere professionellen und erfahrenen Mitarbeitenden sorgen mit Freundlichkeit und Aufmerksamkeit für einen reibungslosen Ablauf.",
          featuresTitle: "Unser Service umfasst:",
          features: [
            "Begrüssung und Platzierung der Gäste",
            "Servieren von Getränken",
            "Servieren des Apéros",
            "Betreuung der Gäste während des Anlasses",
            "Laufendes Abräumen von Gläsern und Geschirr",
            "Unterstützung für einen gepflegten und organisierten Ablauf",
          ],
          extra: "Bitte beachtet, dass das Servieren von warmen Buffets oder Hauptgerichten nicht zu unserem Service gehört.",
        },
        security: {
          name: "Security",
          price: "Preis auf Anfrage",
          intro: "Damit euer Anlass sicher und entspannt verläuft, sorgt unser Security-Team für Ruhe, Ordnung und einen professionellen Ablauf. Unsere geschulten Sicherheitsmitarbeitenden handeln diskret, aufmerksam und situationsgerecht.",
          featuresTitle: "Unser Security-Service umfasst:",
          features: [
            "Zutritts- und Einlasskontrollen",
            "Kontrolle der Gästebereiche",
            "Präsenz während des gesamten Anlasses",
            "Vorbeugung und Deeskalation bei Konflikten",
            "Unterstützung bei Notfällen und besonderen Situationen",
            "Zusammenarbeit mit Veranstaltenden und Einsatzkräften, wenn nötig",
          ],
          extra: "Unser Ziel ist es, dass sich eure Gäste jederzeit sicher und wohl fühlen. Preis auf Anfrage, je nach Anzahl Personen und Aufwand. Mindestbuchung: 2 Personen. Spesen werden separat verrechnet.",
        },
      },
    },
    impressions: {
      overline: "Eindrücke",
      title: "Eure besonderen Momente",
      sub: "Freigegebene Eindrücke und echte Bewertungen unserer Kundinnen und Kunden",
      filters: { all: "Alle", hochzeit: "Hochzeit", verlobung: "Verlobung", geburtstag: "Geburtstag", firmenevent: "Firmenevent", weitere: "Weitere" },
      emptyGallery: "Sobald Kundinnen und Kunden ihre Bilder freigeben, erscheinen sie hier.",
      emptyReviews: "Noch keine veröffentlichten Bewertungen.",
      shareTitle: "Erlebnis teilen",
      shareSub: "Teilt eure schönsten Momente und eure Erfahrung mit uns.",
      shareBtn: "Erlebnis teilen",
      avgLabel: "Durchschnitt aus {n} Bewertungen",
    },
    reviewForm: {
      title: "Erlebnis teilen",
      name: "Name",
      email: "E-Mail-Adresse",
      eventType: "Anlassart",
      date: "Datum",
      text: "Erfahrungsbericht",
      rating: "Bewertung",
      instagram: "Instagram-Name",
      upload: "Fotos hochladen",
      uploadHint: "Bis zu 10 Bilder (JPG, PNG, WebP)",
      consent: "Ich bin mit der Veröffentlichung der ausgewählten Bilder und meines Erfahrungsberichtes auf der Website von Our Promise Events einverstanden.",
      privacyNote: "Eure Angaben werden vertraulich behandelt. Uploads und Bewertungen werden erst nach manueller Freigabe veröffentlicht.",
      submit: "Bewertung abgeben",
      success: "Vielen Dank! Eure Bewertung wurde übermittelt und erscheint nach der Freigabe.",
      consentRequired: "Bitte bestätigt die Einwilligung zur Veröffentlichung.",
    },
    inquiry: {
      overline: "Unverbindliche Anfrage",
      title: "Anfrage senden",
      sub: "Erzählt uns von eurem Anlass – wir prüfen die Verfügbarkeit und melden uns persönlich.",
      steps: ["Anlass", "Details", "Wünsche", "Kontakt"],
      eventType: "Anlassart",
      eventTypes: ["Hochzeit", "Verlobung", "Weitere"],
      date: "Wunschdatum",
      altDate: "Ersatzdatum",
      location: "Ort oder Region",
      guests: "Anzahl Gäste",
      package: "Gewünschtes Package",
      selectPackage: "Package auswählen",
      noPackage: "Noch offen",
      servicesLabel: "Gewünschte zusätzliche Services",
      budget: "Geschätztes Budget",
      name: "Name",
      email: "E-Mail-Adresse",
      phone: "Telefonnummer",
      message: "Wünsche und Nachricht",
      consent: "Ich habe die Datenschutzbestimmungen gelesen und bin einverstanden.",
      summaryTitle: "Zusammenfassung",
      submit: "Anfrage senden",
      successTitle: "Vielen Dank für eure Anfrage",
      success: "Wir prüfen die Verfügbarkeit und melden uns persönlich bei euch. Eine Bestätigung wurde an eure E-Mail-Adresse gesendet.",
      newInquiry: "Neue Anfrage",
      consentRequired: "Bitte bestätigt die Datenschutzbestimmungen.",
      pickDate: "Datum auswählen",
    },
    consultation: {
      overline: "Kennenlerngespräch",
      title: "Termin buchen",
      sub: "Wählt einen freien Termin für ein unverbindliches Kennenlerngespräch (Zeitzone Europe/Zürich).",
      noSlots: "Aktuell sind keine Termine verfügbar. Sendet uns gerne eine Anfrage – wir melden uns mit passenden Terminen.",
      chooseSlot: "Freien Termin wählen",
      name: "Name",
      email: "E-Mail-Adresse",
      phone: "Telefonnummer",
      message: "Nachricht",
      book: "Termin bestätigen",
      successTitle: "Termin bestätigt",
      success: "Euer Kennenlerngespräch ist gebucht. Ihr erhaltet eine Bestätigung inklusive Kalenderdatei per E-Mail.",
      downloadIcs: "Kalenderdatei herunterladen",
      newBooking: "Weiteren Termin buchen",
      selected: "Ausgewählt",
    },
    faq: {
      overline: "FAQ",
      title: "Häufige Fragen",
      items: [
        { q: "In welchen Regionen seid ihr tätig?", a: "Wir sind in der ganzen Schweiz für euch da. Für Anlässe ausserhalb unserer Region klären wir Anreise und Spesen individuell." },
        { q: "Wie früh sollten wir anfragen?", a: "Je früher, desto besser – idealerweise 6 bis 12 Monate im Voraus. Die benötigte Vorlaufzeit hängt auch von der Grösse und Art des Events ab: Eine Hochzeit erfordert in der Regel mehr Vorbereitungszeit als ein kleiner Geburtstag. Auch kurzfristige Anfragen prüfen wir gerne." },
        { q: "Können die Services auch ohne Package gebucht werden?", a: "Ja. Reinigungsservice, Service-Team und Security können einzeln und unabhängig von einem Package gebucht werden." },
        { q: "Wie werden Zusatzleistungen und Spesen verrechnet?", a: "Zusätzliche Wünsche und Fremdkosten, die nicht ausdrücklich enthalten sind, werden je nach Aufwand separat offeriert und verrechnet." },
        { q: "Was gehört nicht zum Service-Team?", a: "Das Servieren von warmen Buffets oder Hauptgerichten gehört nicht zu den regulären Leistungen unseres Service-Teams. Dieser Service kann jedoch separat dazugebucht werden. Die Kosten werden individuell anhand der Grösse des Events und des dafür benötigten Personals berechnet." },
        { q: "Wie funktioniert eine Termin- oder Datumsanfrage?", a: "Über das Anfrageformular sendet ihr uns euer Wunschdatum. Wir prüfen die Verfügbarkeit und melden uns persönlich. Verbindlich wird es erst nach unserer Bestätigung." },
        { q: "Wann werden hochgeladene Fotos veröffentlicht?", a: "Hochgeladene Fotos und Bewertungen werden erst nach einer manuellen Freigabe durch uns veröffentlicht." },
        { q: "Können veröffentlichte Fotos später entfernt werden?", a: "Ja. Ihr könnt jederzeit die Entfernung eurer Bilder und Bewertungen verlangen." },
        { q: "Sind Fremdkosten in den Package-Preisen enthalten?", a: "Nein. Fremdkosten sind in den Package-Preisen nicht enthalten und werden separat offeriert." },
        { q: "Ist die Erstellung der Einladungen bzw. Internetseite im Preis enthalten?", a: "Die Gestaltung und Erstellung der Einladungen ist im Package enthalten. Die Kosten für den Druck bzw. die Produktion der Einladungen sowie die Erstellung einer Internetseite sind nicht im Package-Preis enthalten und werden separat berechnet." },
        { q: "Wer erhält die Rechte an den Fotos des Anlasses?", a: "Mit Vertragsabschluss erhält Our Promise Event das Recht, die am Anlass entstandenen Fotos für eigene Zwecke zu verwenden (z. B. Website, Social Media, Portfolio). Dabei beachten wir stets den Datenschutz: Eine Veröffentlichung erfolgt nur unter Wahrung eurer Persönlichkeitsrechte, und ihr könnt der Verwendung einzelner Bilder jederzeit widersprechen." },
      ],
    },
    contact: {
      overline: "Kontakt",
      title: "Lasst uns reden",
      sub: "Wir freuen uns auf eure Nachricht.",
      name: "Name",
      email: "E-Mail-Adresse",
      phone: "Telefon",
      message: "Nachricht",
      submit: "Nachricht senden",
      success: "Nachricht gesendet. Wir melden uns bald bei euch.",
      addressPlaceholder: "Adresse auf Anfrage",
      phoneLabel: "Telefon",
      emailLabel: "E-Mail",
      social: "Social Media",
    },
    footer: {
      claim: "Planung, Organisation & Koordination von Hochzeiten und Events",
      nav: "Navigation",
      contact: "Kontakt",
      legal: "Rechtliches",
      imprint: "Impressum",
      privacy: "Datenschutz",
      cookies: "Cookie-Einstellungen",
      rights: "Alle Rechte vorbehalten.",
    },
    cookie: {
      text: "Wir verwenden nur technisch notwendige Cookies für den Betrieb dieser Website. Es werden keine Tracking- oder Marketing-Cookies gesetzt.",
      accept: "Verstanden",
      settings: "Cookie-Einstellungen",
    },
    legal: {
      imprintTitle: "Impressum",
      privacyTitle: "Datenschutz",
      cookiesTitle: "Cookie-Einstellungen",
      responsible: "Verantwortlich",
      contact: "Kontakt",
    },
    admin: {
      loginTitle: "Admin-Login",
      email: "E-Mail",
      password: "Passwort",
      login: "Anmelden",
      logout: "Abmelden",
      dashboard: "Dashboard",
      tabs: { inquiries: "Anfragen", messages: "Nachrichten", reviews: "Bewertungen", slots: "Termine", consultations: "Gespräche", content: "Inhalte" },
      empty: "Keine Einträge vorhanden.",
      inquiryStatus: { neu: "Neu", in_abklaerung: "In Abklärung", angebot_gesendet: "Angebot gesendet", bestaetigt: "Bestätigt", abgelehnt: "Abgelehnt" },
      reviewStatus: { pending: "Ausstehend", approved: "Freigegeben", rejected: "Abgelehnt" },
      messageStatus: { neu: "Neu", gelesen: "Gelesen" },
      approve: "Freigeben",
      reject: "Ablehnen",
      delete: "Löschen",
      highlight: "Highlight",
      addSlot: "Termin hinzufügen",
      slotDate: "Datum",
      slotTime: "Uhrzeit",
      booked: "Gebucht",
      free: "Frei",
      save: "Speichern",
      saved: "Gespeichert",
      contentHint: "Preise und Kontaktdaten bearbeiten. Änderungen erscheinen sofort auf der Website.",
    },
  },

  fr: {
    nav: {
      home: "Accueil",
      about: "À propos",
      packages: "Forfaits",
      services: "Services",
      impressions: "Impressions",
      reviews: "Avis",
      faq: "FAQ",
      contact: "Contact",
      cta: "Réserver un entretien",
      inquiry: "Faire une demande",
    },
    common: {
      more: "En savoir plus",
      requestPackage: "Demander ce package",
      requestService: "Demander ce service",
      priceOnRequest: "Prix sur demande",
      from: "dès",
      send: "Envoyer",
      sending: "Envoi en cours…",
      back: "Retour",
      next: "Suivant",
      required: "Champ obligatoire",
      optional: "facultatif",
      loading: "Chargement…",
    },
    hero: {
      brand: "Our Promise Events",
      claim: "Votre vision.\nNotre promesse.",
      subtitle: "Mariages et événements – pensés avec cœur, réalisés avec élégance.",
      cta1: "Découvrir nos packages",
      cta2: "Faire une demande",
    },
    brandMessage: {
      overline: "Bienvenue",
      title: "Votre événement. Entre de bonnes mains.",
      body: "Our Promise Events vous accompagne personnellement, organise avec soin et veille à une réalisation élégante. Détendez-vous et profitez de votre événement – nous nous occupons de la planification, de l'organisation et de la coordination.",
    },
    process: {
      overline: "Déroulement",
      title: "En quatre étapes vers votre jour",
      steps: [
        { t: "Rencontre", d: "Nous apprenons à vous connaître, vous et vos souhaits." },
        { t: "Souhaits & concept", d: "Ensemble, nous définissons le concept, le style et le cadre." },
        { t: "Planification & coordination", d: "Nous organisons, négocions et coordonnons chaque détail." },
        { t: "Profiter sereinement", d: "Vous profitez de votre événement – nous nous occupons du reste." },
      ],
    },
    home: {
      packagesOverline: "Forfaits",
      packagesTitle: "Nos forfaits",
      packagesSub: "Trois chemins vers votre journée parfaite",
      servicesOverline: "Services",
      servicesTitle: "Nos services",
      servicesSub: "Un soutien professionnel pour votre événement",
      impressionsOverline: "Impressions & avis",
      impressionsTitle: "Des moments qui restent",
      impressionsSub: "Impressions sélectionnées et validées de nos clients",
      reviewsOverline: "Avis",
      reviewsTitle: "Ce que disent nos clients",
      instagramOverline: "Suivez-nous",
      instagramTitle: "Nos moments sur Instagram",
      instagramSub: "Coulisses, moments d'inspiration et événements du moment.",
      instagramCta: "Suivre sur Instagram",
      finalTitle: "Planifions ensemble votre événement spécial.",
      finalSub: "Mariage, fiançailles ou événement d'entreprise – nous vous accompagnons de la première idée au moindre détail.",
    },
    about: {
      overline: "À propos",
      title: "Avec cœur, structure et style",
      founderTitle: "Faisons connaissance",
      founderName: "M. Koko",
      founderRole: "Fondatrice & gérante",
      valuesTitle: "Nos valeurs",
      storyTitle: "Notre histoire",
      teamTitle: "Notre équipe",
      teamEmpty: "Notre équipe sera présentée prochainement.",
      paragraphs: [
        "Chaque événement inoubliable commence par une vision. C'est de cette vision qu'est né Our Promise Event.",
        "Je m'appelle M. Koko, fondatrice et gérante de Our Promise Event. Tout a commencé avec l'organisation de mon propre mariage, puis de baby showers et d'anniversaires pour ma famille et mes proches. Ce qui était au départ une simple passion est devenu un véritable projet de cœur, puis une entreprise qui me permet aujourd'hui de faire ce que j'aime le plus : créer des moments inoubliables.",
        "Pour moi, Our Promise Event est bien plus qu'une entreprise. C'est une façon d'offrir aux gens des instants précieux qu'ils garderont dans leur cœur pendant de nombreuses années. Je suis convaincue que les souvenirs sont ce que nous avons de plus précieux. C'est pourquoi je mets tout mon cœur, mon énergie et ma créativité dans chaque événement.",
        "Chaque célébration est unique et raconte une histoire. Mon rôle est d'écouter, de comprendre les envies de chaque client et de transformer leurs idées en une journée qui leur ressemble. Avec beaucoup de créativité, d'attention aux détails et une organisation soignée, je veille à ce que chaque événement soit à la hauteur de leurs attentes.",
        "Je tiens également à montrer qu'il est possible de créer un événement élégant et mémorable sans devoir dépenser une fortune. Grâce à une bonne préparation et à des solutions adaptées, je propose des projets qui respectent le budget de chacun, tout en offrant une belle qualité, une ambiance chaleureuse et des souvenirs inoubliables.",
      ],
      teamIntro: "Créer des moments qui restent gravés dans les mémoires a toujours été ma plus grande motivation. C'est aussi cette vision qui m'a guidée dans le choix de mon équipe. Derrière Our Promise Event, il y a des personnes qui m'accompagnent parfois depuis de nombreuses années.",
      teamParagraphs: [
        "Notre équipe est composée de professionnels qualifiés qui exercent leur métier avec passion. Que ce soit dans le service, le nettoyage, la sécurité, l'informatique ou d'autres domaines, chacun apporte son savoir-faire, son expérience et son engagement.",
        "Ensemble, nous partageons le même objectif : accompagner nos clients avec sérieux, bienveillance et passion. Car au final, ce ne sont pas les biens matériels qui restent, mais les émotions, les sourires et les souvenirs précieux que nous créons ensemble.",
      ],
    },
    packages: {
      overline: "Tarifs & prestations",
      title: "Forfaits",
      sub: "Planification et coordination d'événement",
      highlight: "Accompagnement le plus complet",
      note: "Les souhaits supplémentaires et les frais de prestataires qui ne sont pas expressément inclus font l'objet d'une offre séparée.",
      cta: "Demander ce package",
      items: {
        bronze: {
          name: "Package Bronze",
          features: [
            "2 rendez-vous",
            "Demande et négociation des offres",
            "Conclusion de tous les contrats nécessaires pour le jour de l'événement",
            "Création et discussion du planning de la journée",
          ],
        },
        silber: {
          name: "Package Argent",
          features: [
            "2 rendez-vous",
            "Demande et négociation des offres",
            "Conclusion de tous les contrats nécessaires pour le jour de l'événement",
            "Création du planning de la journée",
            "Création et commande des invitations (frais d'impression non inclus)",
            "Création d'un site internet (non compris dans le prix du package)",
          ],
        },
        gold: {
          name: "Package Or",
          features: [
            "3 à 4 rendez-vous",
            "Demande et négociation des offres",
            "Conclusion de tous les contrats nécessaires pour le jour de l'événement",
            "Création du planning de la journée",
            "Création et commande des invitations (frais d'impression non inclus)",
            "Création d'un site internet (non compris dans le prix du package)",
            "Coordination le jour de l'événement de 07 h 00 à 22 h 30",
          ],
        },
      },
    },
    services: {
      overline: "Services",
      title: "Nos services",
      sub: "Chaque service peut être demandé séparément",
      surcharge: "Les prestations supplémentaires et les frais sont facturés séparément selon le travail nécessaire.",
      cta: "Demander ce service",
      list: {
        reinigungsservice: {
          name: "Service de nettoyage",
          price: "CHF 2'060.–",
          intro: "Profitez pleinement de votre événement : nous nous occupons du reste, y compris du nettoyage. Notre équipe est composée de professionnelles qualifiées et expérimentées.",
          featuresTitle: "Notre service comprend :",
          features: [
            "Le contrôle et l'entretien régulier des espaces intérieurs et extérieurs pendant l'événement",
            "Le lavage de la vaisselle, des verres et des couverts",
            "Le nettoyage des sanitaires",
            "Le nettoyage des tables et des surfaces",
            "Le balayage des sols",
          ],
          extra: "Si nécessaire, nous pouvons également nous charger du rangement et du nettoyage de la cuisine, si cette prestation n'est pas déjà assurée par l'équipe de catering. Le lavage humide des sols peut également être ajouté. Ces prestations supplémentaires sont facturées séparément. Nous veillons à ce que votre lieu reste propre, soigné et prêt à être restitué après votre événement.",
        },
        serviceTeam: {
          name: "Équipe de service",
          price: "CHF 2'540.–",
          intro: "Profitez pleinement de votre événement : notre équipe de service s'occupe de vos invités avec professionnalisme, amabilité et attention.",
          featuresTitle: "Notre service comprend :",
          features: [
            "L'accueil et le placement des invités",
            "Le service des boissons",
            "Le service de l'apéritif",
            "L'accompagnement des invités pendant l'événement",
            "Le débarrassage régulier des verres et de la vaisselle",
            "Une présence attentive pour garantir une organisation soignée",
          ],
          extra: "Veuillez noter que le service des buffets chauds et des plats principaux ne fait pas partie de nos prestations.",
        },
        security: {
          name: "Sécurité",
          price: "Prix sur demande",
          intro: "La sécurité de votre événement est notre priorité. Notre équipe qualifiée veille à ce que tout se déroule dans le calme et en toute sécurité, avec discrétion et professionnalisme.",
          featuresTitle: "Notre service comprend :",
          features: [
            "Le contrôle des entrées et des accès",
            "La surveillance des espaces réservés aux invités",
            "Une présence discrète pendant toute la durée de l'événement",
            "La prévention et la désescalade des conflits",
            "Une assistance rapide en cas d'urgence ou de situation particulière",
            "Une bonne collaboration avec les organisateurs et les services d'intervention, si nécessaire",
          ],
          extra: "Notre priorité est d'assurer la sécurité et le bien-être de vos invités. Prix sur demande, selon le nombre de personnes et le travail à effectuer. Réservation minimale : 2 personnes. Frais facturés séparément.",
        },
      },
    },
    impressions: {
      overline: "Impressions",
      title: "Vos moments inoubliables",
      sub: "Impressions validées et avis authentiques de nos clients",
      filters: { all: "Tout", hochzeit: "Mariage", verlobung: "Fiançailles", geburtstag: "Anniversaire", firmenevent: "Événement d'entreprise", weitere: "Autres" },
      emptyGallery: "Dès que nos clients partageront leurs photos, elles apparaîtront ici.",
      emptyReviews: "Aucun avis publié pour le moment.",
      shareTitle: "Partager votre expérience",
      shareSub: "Partagez vos plus beaux moments et votre expérience avec nous.",
      shareBtn: "Partager votre expérience",
      avgLabel: "Moyenne sur {n} avis",
    },
    reviewForm: {
      title: "Partager votre expérience",
      name: "Nom",
      email: "Adresse e-mail",
      eventType: "Type d'événement",
      date: "Date",
      text: "Votre témoignage",
      rating: "Évaluation",
      instagram: "Nom Instagram",
      upload: "Télécharger des photos",
      uploadHint: "Jusqu'à 10 images (JPG, PNG, WebP)",
      consent: "J'accepte la publication des photos sélectionnées et de mon témoignage sur le site d'Our Promise Events.",
      privacyNote: "Vos données sont traitées de manière confidentielle. Les photos et avis ne sont publiés qu'après validation manuelle.",
      submit: "Donner votre avis",
      success: "Merci ! Votre avis a été transmis et apparaîtra après validation.",
      consentRequired: "Veuillez confirmer votre consentement à la publication.",
    },
    inquiry: {
      overline: "Demande sans engagement",
      title: "Envoyer une demande",
      sub: "Parlez-nous de votre événement – nous vérifions la disponibilité et vous répondons personnellement.",
      steps: ["Événement", "Détails", "Souhaits", "Contact"],
      eventType: "Type d'événement",
      eventTypes: ["Mariage", "Fiançailles", "Autres"],
      date: "Date souhaitée",
      altDate: "Date de remplacement",
      location: "Lieu ou région",
      guests: "Nombre d'invités",
      package: "Forfait souhaité",
      selectPackage: "Sélectionner un forfait",
      noPackage: "Encore ouvert",
      servicesLabel: "Services supplémentaires souhaités",
      budget: "Budget estimé",
      name: "Nom",
      email: "Adresse e-mail",
      phone: "Numéro de téléphone",
      message: "Souhaits et message",
      consent: "J'ai lu et j'accepte la politique de confidentialité.",
      summaryTitle: "Récapitulatif",
      submit: "Envoyer la demande",
      successTitle: "Merci pour votre demande",
      success: "Nous vérifions la disponibilité et vous répondons personnellement. Une confirmation a été envoyée à votre adresse e-mail.",
      newInquiry: "Nouvelle demande",
      consentRequired: "Veuillez confirmer la politique de confidentialité.",
      pickDate: "Choisir une date",
    },
    consultation: {
      overline: "Entretien de découverte",
      title: "Réserver un rendez-vous",
      sub: "Choisissez un créneau libre pour un entretien sans engagement (fuseau Europe/Zurich).",
      noSlots: "Aucun créneau disponible pour le moment. Envoyez-nous une demande – nous vous proposerons des dates.",
      chooseSlot: "Choisir un créneau libre",
      name: "Nom",
      email: "Adresse e-mail",
      phone: "Numéro de téléphone",
      message: "Message",
      book: "Confirmer le rendez-vous",
      successTitle: "Rendez-vous confirmé",
      success: "Votre entretien est réservé. Vous recevrez une confirmation avec un fichier calendrier par e-mail.",
      downloadIcs: "Télécharger le fichier calendrier",
      newBooking: "Réserver un autre rendez-vous",
      selected: "Sélectionné",
    },
    faq: {
      overline: "FAQ",
      title: "Questions fréquentes",
      items: [
        { q: "Dans quelles régions êtes-vous actifs ?", a: "Nous sommes à votre disposition dans toute la Suisse. Pour les événements hors de notre région, nous clarifions individuellement le déplacement et les frais." },
        { q: "Quand devrions-nous faire notre demande ?", a: "Le plus tôt possible – idéalement 6 à 12 mois à l'avance. Le délai nécessaire dépend aussi de la taille et du type d'événement : un mariage demande généralement plus de préparation qu'un petit anniversaire. Nous étudions également volontiers les demandes de dernière minute." },
        { q: "Les services peuvent-ils être réservés sans forfait ?", a: "Oui. Le service de nettoyage, l'équipe de service et la sécurité peuvent être réservés séparément, indépendamment d'un forfait." },
        { q: "Comment les prestations supplémentaires et les frais sont-ils facturés ?", a: "Les souhaits supplémentaires et les frais de prestataires non expressément inclus font l'objet d'une offre séparée, facturée selon le travail nécessaire." },
        { q: "Qu'est-ce qui ne fait pas partie de l'équipe de service ?", a: "Le service des buffets chauds et des plats principaux ne fait pas partie des prestations habituelles de notre équipe de service. Ce service peut toutefois être réservé séparément. Les coûts sont calculés individuellement selon la taille de l'événement et le personnel nécessaire." },
        { q: "Comment fonctionne une demande de date ou de rendez-vous ?", a: "Via le formulaire de demande, vous nous transmettez votre date souhaitée. Nous vérifions la disponibilité et vous répondons personnellement. La réservation devient ferme après notre confirmation." },
        { q: "Quand les photos téléchargées sont-elles publiées ?", a: "Les photos et les avis téléchargés ne sont publiés qu'après une validation manuelle de notre part." },
        { q: "Les photos publiées peuvent-elles être supprimées plus tard ?", a: "Oui. Vous pouvez à tout moment demander la suppression de vos photos et de vos avis." },
        { q: "Les frais de prestataires sont-ils inclus dans les prix des forfaits ?", a: "Non. Les frais de prestataires ne sont pas inclus dans les prix des forfaits et font l'objet d'une offre séparée." },
        { q: "La création des invitations ou du site internet est-elle comprise dans le prix ?", a: "La conception et la création des invitations sont comprises dans le forfait. Les frais d'impression et de production des invitations ainsi que la création d'un site internet ne sont pas inclus dans le prix du forfait et sont facturés séparément." },
        { q: "Qui obtient les droits sur les photos de l'événement ?", a: "À la signature du contrat, Our Promise Event obtient le droit d'utiliser les photos prises lors de l'événement à ses propres fins (site web, réseaux sociaux, portfolio). Nous respectons toujours la protection des données : toute publication se fait dans le respect de vos droits de la personnalité, et vous pouvez à tout moment vous opposer à l'utilisation de certaines images." },
      ],
    },
    contact: {
      overline: "Contact",
      title: "Parlons ensemble",
      sub: "Nous serions ravis d'avoir de vos nouvelles.",
      name: "Nom",
      email: "Adresse e-mail",
      phone: "Téléphone",
      message: "Message",
      submit: "Envoyer le message",
      success: "Message envoyé. Nous vous recontactons bientôt.",
      addressPlaceholder: "Adresse sur demande",
      phoneLabel: "Téléphone",
      emailLabel: "E-mail",
      social: "Réseaux sociaux",
    },
    footer: {
      claim: "Planification, organisation et coordination de mariages et d'événements",
      nav: "Navigation",
      contact: "Contact",
      legal: "Mentions légales",
      imprint: "Mentions légales",
      privacy: "Confidentialité",
      cookies: "Paramètres des cookies",
      rights: "Tous droits réservés.",
    },
    cookie: {
      text: "Nous utilisons uniquement des cookies techniquement nécessaires au fonctionnement de ce site. Aucun cookie de suivi ou de marketing n'est utilisé.",
      accept: "Compris",
      settings: "Paramètres des cookies",
    },
    legal: {
      imprintTitle: "Mentions légales",
      privacyTitle: "Confidentialité",
      cookiesTitle: "Paramètres des cookies",
      responsible: "Responsable",
      contact: "Contact",
    },
    admin: {
      loginTitle: "Connexion admin",
      email: "E-mail",
      password: "Mot de passe",
      login: "Connexion",
      logout: "Déconnexion",
      dashboard: "Tableau de bord",
      tabs: { inquiries: "Demandes", messages: "Messages", reviews: "Avis", slots: "Créneaux", consultations: "Entretiens", content: "Contenus" },
      empty: "Aucune entrée.",
      inquiryStatus: { neu: "Nouveau", in_abklaerung: "En cours", angebot_gesendet: "Offre envoyée", bestaetigt: "Confirmé", abgelehnt: "Refusé" },
      reviewStatus: { pending: "En attente", approved: "Validé", rejected: "Refusé" },
      messageStatus: { neu: "Nouveau", gelesen: "Lu" },
      approve: "Valider",
      reject: "Refuser",
      delete: "Supprimer",
      highlight: "Mettre en avant",
      addSlot: "Ajouter un créneau",
      slotDate: "Date",
      slotTime: "Heure",
      booked: "Réservé",
      free: "Libre",
      save: "Enregistrer",
      saved: "Enregistré",
      contentHint: "Modifier les prix et les coordonnées. Les changements apparaissent immédiatement sur le site.",
    },
  },
};
